module.exports = __webpack_public_path__ + "static/media/214-Sturz-Milo_ID_4.69e662ba.mp3";